module.exports = __webpack_public_path__ + "img/monitoring-tow-blue.424f88fe.svg";